


import { setGetMailingStatisticsDashboardAction } from '../action';
import { getMailingStatisticsDashboard } from '../api/getMailingStatisticsDashboard';

export const setGetMailingStatisticsDashboard = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsDashboard({
                ...params
            });

            dispatch(setGetMailingStatisticsDashboardAction(data));
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}